import { Injectable } from '@angular/core';
import { Order, QueryEntity } from '@datorama/akita';
import { compareEntities, isEquals } from '@lycoris-nubila/ngx-lycoris';
import { isEqual, isNil, reject, uniqBy } from 'lodash-es';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map, shareReplay } from 'rxjs/operators';

import { SectionRepositoryPort } from 'phase/section/port/section-repository.port';
import { Section } from 'phase/section/section';

import { CacheObservable } from '../../../app-decorators';
import { SectionState, SectionStore } from './section.store';

@Injectable()
export class SectionRepositoryAdapter
	extends QueryEntity<SectionState>
	implements SectionRepositoryPort
{
	constructor(protected store: SectionStore) {
		super(store);
	}

	public observeSection(sectionId: string): Observable<Section> {
		return this.selectEntity(sectionId).pipe(
			distinctUntilChanged(isEqual),
			map((document) => this.store.asEntity(document))
		);
	}

	@CacheObservable()
	public observeSectionByPhaseId(phaseId: string): Observable<Section[]> {
		return this.selectAll({
			filterBy: (entity) => isEquals(entity.phaseId, phaseId),
			sortByOrder: Order.ASC,
			sortBy: 'position',
		}).pipe(
			map((documents) =>
				documents.map((document) => this.store.asEntity(document))
			),
			distinctUntilChanged(compareEntities),
			shareReplay({ bufferSize: 1, refCount: true })
		);
	}

	public async saveSections(entities: Section[]): Promise<void> {
		this.store.upsertMany(
			uniqBy(
				reject(entities, isNil).map((e) => this.store.asDocument(e)),
				'id'
			)
		);
	}
}
